import { StorageService } from 'src/app/services/storage/storage.service';
import { PushNotificationsManagerService } from './../../../components/push-notifications-manager/push-notifications-manager.service';
import {
  Component,
  EventEmitter,
  Injectable,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { formatDate } from '@angular/common';
import { IonRouterOutlet, ModalController, Platform } from '@ionic/angular';
import firebase from 'firebase/app';

import { Plugins } from '@capacitor/core';
const { SplashScreen, Browser } = Plugins;
//Services
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { CatalogueService } from 'src/app/services/catalogue/catalogue.service';
import { RouterService } from 'src/app/services/router/router.service';
import { CredentialsService } from 'src/app/services/credentials/credentials.service';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { NotificationsChannelsPage } from '../notifications-channels/notifications-channels.page';
import { ValidateVersionService } from '../../../services/validateVersion/validate-version.service';
import { ContentService } from '../../../services/content/content.service';
import { PointsService } from '../../../services/points/points.service';
import { UtilsService } from '../../../services/utils/utils.service';
import { SheetState } from 'ion-bottom-sheet';
import { TagsService } from 'src/app/services/tags/tags.service';
import { CatalogueDetailComponent } from 'src/app/components/catalogue-detail/catalogue-detail.component';
import { MessagingService } from 'src/app/services/messaging/messaging.service';
import { AlertController, ToastController } from '@ionic/angular';
import { Observable, Subscription, timer } from 'rxjs';
import { FcmService } from 'src/app/services/fcm/fcm.service';
import { RedemptionService } from 'src/app/services/redemption/redemption.service';
import { ActivationStart, Router } from '@angular/router';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { LOADER_ID_LOGIN } from '../../public/login/login.page';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss'],
  providers: [TagsService],
})
export class HomePage implements OnInit, OnDestroy {
  db: any;
  userName: string;
  news: any;
  outstanding: any = [];
  public BottomSheetState = SheetState.Bottom;
  points: any;
  minHeight = 200;
  dockedHeight = 100;
  canBounce = true;
  topDistance = 30;
  hideCloseButton = false;
  hideDragIcon = false;
  roundBorderOnTop = false;
  disableDrag = false;
  infoFlagSheetNew: any = null;
  kpiblock: boolean = true;
  program: any;
  programs: any = [];
  flagProcess: boolean = false; // valida que ya entro a notification y destacados
  categories: any;
  subcategories: any;
  public termCondition$ = new EventEmitter<any>();
  redemptionLimit = false;
  isRedemptionActive = false;
  subscription
  intentVerifyTerms$: Subscription;
  newsPost: any;
  constructor(
    public authService: AuthService,
    public userService: UserService,
    private routerService: RouterService,
    private credentialsService: CredentialsService,
    public remoteConfigService: RemoteConfigService,
    public catalogueService: CatalogueService,
    public alertService: AlertService,
    public languageService: LanguagesService,
    private modalController: ModalController,
    private validateVersion: ValidateVersionService,
    private contentService: ContentService,
    private pointsService: PointsService,
    private utilsService: UtilsService,
    private tagsService: TagsService,
    private platform: Platform,
    private messagingService: MessagingService,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private fcmService: FcmService,
    private redemptionService: RedemptionService,
    private pushNotificationsManagerService: PushNotificationsManagerService,
    private routerOutlet: IonRouterOutlet,
    private storageServices: StorageService,
    private loaderService: LoaderService
  ) {
    //firebase.initializeApp(environment.firebaseConfig);
    this.tagsService.setEventTag('home_page', 'home_screen_viewed', true, true);
    this.getUserNameGNX();
    this.db = firebase ? firebase : undefined;
    this.authService.saveGlobalUser();

    // clevetapService.pushEvent("Product viewed", evtData);
  }

  ionViewDidLeave() {
    this.routerOutlet.swipeGesture = true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.intentVerifyTerms$) {
      this.intentVerifyTerms$.unsubscribe();
    }
  }

  hideBottomSheet(){}

  ngOnDestroy(): void {
    this.routerOutlet.swipeGesture = true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.intentVerifyTerms$) {
      this.intentVerifyTerms$.unsubscribe();
    }
  }

  async ngOnInit() {
    // let buttonCatalogue =document.querySelector("#menuContent > app-tabs > div > ion-tabs > div > ion-router-outlet > app-home > ion-content > ion-grid > div:nth-child(5) > ion-card > gnx-catalogue > gnx-catalogue-carousel > ion-grid > ion-row > ion-col.ion-text-end.md.hydrated > ion-button");
    // buttonCatalogue.classList.add("ion-color-secondary");
    // buttonCatalogue.classList.remove("ion-color-primary");
    await this.updateUser();
    await this.updateUserProgramId();
    this.alertService.closeAlert();
    this.fcmService.initPush();
    this.userService.checkIfProfileComplete();
    this.checkTermsConditions();
    this.validateVersion.validate();
    this.getNews();

    this.utilsService.getUserPoints().then((result: any) => {
      this.points = result;
    });
    let _this = this;
    window.addEventListener('kpiStatus', function (event: any) {
      if (event && event.detail && event.detail.length <= 0) {
        _this.kpiblock = false;
      }
    });
    this.getCategories();
    this.getSubcategories();
    this.listenForMessages();
    this.checkRedemption();
    const element = <HTMLStyleElement>(
      document.querySelector('.gnx-bottomSheet__bg2')
    );
    if (element) element.style.display = 'none';
  }

  async checkRedemption() {
    const programInfo = await this.redemptionService.getProgramInfo();
    this.redemptionLimit = programInfo['redemption_limit']?.enabled
      ? true
      : false;
    this.isRedemptionActive = await this.redemptionService.validateRedemption();
  }

  getNews() {

    // this.contentService.getContentType("pages").then((data: any) => {
    //   this.news = data.filter(page => page.typeContent != "TermsAndConditions");
    // });


    this.contentService.getContentType("pages").then((data: any) => {


      this.news = data.filter(page => page.typeContent != "TermsAndConditions");


      this.newsPost = data.filter(page => page.typeContent != "TermsAndConditions" &&  page.Publish);
   console.log("___this.newsPost",this.newsPost);

   this.newsPost.forEach( (val:any) => {
      let urlImage =  this.contentService.getImageUrl(val.preview);
      val.urlImage = urlImage;
   } );


    });
  }

  async checkTermsConditions() {
    this.userService.termCondition$.subscribe((data: any) => {
      if (data == 'true') {
        this.userService.getUserInfo().subscribe(async (info: any) => {
          if (this.flagProcess) {
            return false;
          }
          if (info && !info.notificationTerms) {
            this.modalController.dismiss(null, null, 'modal-terms-conditions');
            this.modalController.dismiss(null, null, 'modal-privacy-policies');
            this.flagProcess = true;
            await this.requestNotificationsTerms();
          }
          if (info && info.outstandingSheet) {
            this.infoFlagSheetNew = info.outstandingSheet;
          }
          this.getOutstanding();
        });
      }
    });
  }

  ionViewDidEnter() {
    SplashScreen.hide();
    this.routerOutlet.swipeGesture = false;
    this.routerOutlet.deactivate();
    this.subscription = this.platform.backButton.subscribeWithPriority(
      9999,
      () => {
        // do nothing
      }
    );

    let intents = 0;
    this.intentVerifyTerms$ = timer(3000, 5000).subscribe(async () => {
      intents = intents + 1;
      const claims = await this.storageServices.get('gnx-claims');
      if (claims) {
        const intentVerifyTerms$ = this.userService
          .getUserInfoWithId(claims.uid)
          .subscribe((data) => {
            console.debug(
              'intentVerifyTerms ionViewDidEnter getUserInfoWithId'
            );
            if (!data?.termsConditions) {
              if (
                (this.routerService.getCurrentUrl() as string)?.includes(
                  '/home'
                )
              ) {
                this.userService.termCondition$.emit('true');
                intentVerifyTerms$.unsubscribe();
                this.intentVerifyTerms$.unsubscribe();
              }
            }
            if (intents >= 5) {
              intentVerifyTerms$.unsubscribe();
              this.intentVerifyTerms$.unsubscribe();
            }
          });
      } else {
        this.intentVerifyTerms$.unsubscribe();
      }
    });
  }

  productSelected(product) {
    if (product.detail === 'go_to_catalogue') {
      return this.routerService.redirect(`app/catalogue`);
    }
    const productId = product.detail.id.raw;
    // @TODO Cuando sea desktop abre el componente como modal
    return this.routerService.redirectRoot(`app/catalogue/${productId}`);
  }

  credentialsCatalogue = async () => {
    return await this.credentialsService.catalogueNew();
  };

  firestoreCredentials = () => {
    return this.db;
  };

  kpiSelected(kpi: any) {
    const kpiId = kpi.idgraph;
    this.routerService.redirect(`app/kpi/${kpiId}`);
  }

  kpiListSelected() {
    this.routerService.redirect(`app/kpi`);
  }

  async getUserNameGNX() {
    this.userService.getUserInfo().subscribe((info: any) => {
      if (info && (info.gnxCredential1 || info.email)) {
        this.userName = info.gnxCredential1 || info.email;
        //TODO - aqui esta seleccionando solo un programa
        if (this.authService.programId && this.authService.programId[0]) {
          this.programs = this.authService.programId[0].split('/');
          this.program = this.programs.slice(-1).pop();
        }
      }
    });
  }

  async requestNotificationsTerms() {
    if (document.getElementById('modal-notifications-channels')) {
      return;
    }
    const modal = await this.modalController.create({
      component: NotificationsChannelsPage,
      id: 'modal-notifications-channels',
      backdropDismiss: false,
    });
    return await modal.present();
  }

  get getTextsIUPageHome() {
    //console.log(this.languageService.textsIU.page_home);
    // console.log("++",this.languageService.textsIU.page_home);
    return this.languageService.textsIU.page_home;
  }
  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }
  onClickChat() {
    console.log('onclick chat');
  }

  getOutstanding() {
    this.contentService.getContentType('outstandings').then((data: any) => {
      this.outstanding = data;
      if (this.infoFlagSheetNew !== null) {
        const currentDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        if (
          this.outstanding.length > 0 &&
          (this.outstanding.length > this.infoFlagSheetNew.cant ||
            currentDate !== this.infoFlagSheetNew.date)
        ) {
          this.BottomSheetState = SheetState.Top;
          (<HTMLStyleElement>(
            document.querySelector('.gnx-bottomSheet__bg2')
          )).style.display = 'block';
        }
      } else {
        (<HTMLStyleElement>(
          document.querySelector('.gnx-bottomSheet__bg2')
        )).style.display = 'block';
        this.BottomSheetState = SheetState.Top;
      }
    });
  }

  closeSheetOutstanding() {
    const dataNews = {
      date: formatDate(new Date(), 'yyyy-MM-dd', 'en'),
      cant: this.outstanding.length,
    };
    (<HTMLStyleElement>(
      document.querySelector('.gnx-bottomSheet__bg2')
    )).style.display = 'none';
    this.userService.updateField('outstandingSheet', dataNews);
    this.BottomSheetState = SheetState.Docked;
  }

  async moreInfoNew(link: any) {
    if (link.Component === 'external') {
      await Browser.open({ url: link.linkId });
    } else {
      return this.routerService.redirect(
        `app/content/outstandings/${link.linkId}`
      );
    }
  }

  credentialsHistoryPoints = () => {
    return this.pointsService.historyCredentials();
  };
  getCategories() {
    this.contentService.getContentType('categories').then((data: any) => {
      this.categories = data.data;
    });
  }

  getSubcategories() {
    this.contentService.getContentType('subcategories').then((data: any) => {
      this.subcategories = data.data;
    });
  }

  //INIT NOTIFICATIONS PWA
  listenForMessages() {
    // this.messagingService.getOnMessages()
    this.messagingService.messageOnBackground$.subscribe(async () => {
      await this.pushNotificationsManagerService.getNotifications();
    });
    this.messagingService.getMessages().subscribe(async (_messaging: any) => {
      const alert = await this.alertCtrl.create({
        header: _messaging.notification.title,
        subHeader: _messaging.notification.body,
        message: _messaging.data.info,
        buttons: ['OK'],
      });
      await alert.present();
      console.log('this.tokenFcm dispositive', '123');
      await this.pushNotificationsManagerService.getNotifications();
    });
  }

  requestPermission() {
    this.messagingService.requestPermission().subscribe(
      async (token) => {
        const toast = await this.toastCtrl.create({
          message: 'Got your token',
          duration: 2000,
        });
        toast.present();
      },
      async (err) => {
        const alert = await this.alertCtrl.create({
          header: 'Error',
          message: err,
          buttons: ['OK'],
        });

        await alert.present();
      }
    );
  }

  async deleteToken() {
    this.messagingService.deleteToken();
    const toast = await this.toastCtrl.create({
      message: 'Token removed',
      duration: 2000,
    });
    toast.present();
  }
  //END NOTIFICATIONS PWA

  updateUser() {
    this.userService.getUserInfo().subscribe(async (data) => {
      if (!data) {
        const user = await this.storageServices.get('gnx-personal-data');
        const userFirebase = await this.authService.getUSerInfoFromFirebase();
        let data = {
          gnxCredential1: '',
          docNumber: '',
          email: '',
          lastnames: '',
          name: '',
          phone: '',
        };
        data.gnxCredential1 = user?.iddoc;
        data.docNumber = user?.iddoc;
        data.email =
          userFirebase?.email.split('@')[1] == 'nomail.glukynet.com'
            ? ''
            : userFirebase?.email;
        data.lastnames = user?.last_name;
        data.name = user?.name;
        data.phone = userFirebase?.phoneNumber;
        this.userService.saveUserExtraInfo(data);
      }
    });
  }
  updateUserProgramId() {
    this.userService.getUserInfo().subscribe(async (data : any) => {
      if (!data.programId) {
        const tokenGnx = await this.storageServices.get('gnx-token');
        const tokentP = await this.utilsService.parseJwt(tokenGnx);
        let data = {
          programId: '',
        };
        data.programId = tokentP?.gluky?.programs[0];
        this.userService.saveUserExtraInfo(data);
      }
    });
  }
}
